export const environment = {
  //ng build --outputPath ../zcomcardprod/dist/zero-company-portal --prod=true
  production: true,
  apiUrl: 'https://wapi.codezero.app',
  zeroapi: 'https://codezero.app',
  //weblink: 'https://web.codezero.app/brandcard/',
  weblink: 'https://zerobrand.cards/',
  zerobrandcardUrl: 'https://zerobrandcard.com/',
  WALLET_DOMAIN : 'https://wpass.codezero.app',

  /*apiUrl: 'https://dapi.codezero.app',
  zeroapi: 'https://dev.codezero.app',
  weblink: 'https://dev.zerobrand.cards/',
  zerobrandcardUrl: 'https://zerobrandcard.com/',
  WALLET_DOMAIN : 'https://dwpass.codezero.app',*/

  onlyCountries: ["al", "ad", "am", "at", "au", "az", "bd", "br", "bn", "by",
        "be", "ba", "bg", "kh", "ca", "cn", "hr", "cy", "cz", "dk",
        "ee", "fi", "fr", "ge", "de", "gr", "hk", "hu", "is", "in",
        "id", "ie", "it", "jp", "kz", "xk", "lv", "li", "lt", "lu",
        "mo", "my", "mt", "md", "mc", "me", "mm", "nl", "nz", "mk",
        "no", "pk", "ph", "pl", "pt", "ro", "ru", "sm", "rs", "sg",
        "sk", "si", "kr", "es", "se", "ch", "tw", "th", "tr", "ua",
        "gb", "us", "va", "vn"
      ]
};
